// src/App.js
import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import Tracker from './Tracker';

const BG_URL = '/bg.jpg'; // already in /public

export default function App() {
  const [session, setSession] = useState(null);
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [authError, setAuthError] = useState('');

  // keep session current
  useEffect(() => {
    let mounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setSession(data.session ?? null);
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_evt, s) => {
      setSession(s ?? null);
    });

    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe?.();
    };
  }, []);

  const signIn = async (e) => {
    e.preventDefault();
    setAuthError('');
    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password: pass,
    });
    if (error) setAuthError(error.message);
  };

  const signOut = async () => {
    await supabase.auth.signOut();
  };

  if (!session) {
    // WELCOME + LOGIN (dark, with BG + quote)
    return (
      <div
        style={{
          minHeight: '100vh',
          color: '#fff',
          backgroundColor: '#000',
          backgroundImage: `url(${BG_URL})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 520,
            background: 'rgba(0,0,0,0.65)',
            border: '1px solid #222',
            borderRadius: 14,
            padding: 20,
            boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
          }}
        >
          <h1 style={{ margin: 0, textAlign: 'center', letterSpacing: 0.3 }}>
            Milestones
          </h1>
          <p style={{ marginTop: 8, opacity: 0.9, textAlign: 'center' }}>
            “The struggle you’re in today is developing the strength you need for tomorrow.”
          </p>

          <form onSubmit={signIn} style={{ marginTop: 16, display: 'grid', gap: 10 }}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              style={inp}
              autoComplete="email"
            />
            <input
              type="password"
              placeholder="Password"
              value={pass}
              required
              onChange={(e) => setPass(e.target.value)}
              style={inp}
              autoComplete="current-password"
            />
            <button type="submit" style={btnPrimary}>Log in</button>
            {authError && (
              <div style={{ color: '#ff6b6b', fontSize: 13, textAlign: 'center' }}>
                {authError}
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }

  // DASHBOARD SHELL (shows email + logout)
  return (
    <div style={{ minHeight: '100vh', background: '#0b0b0b', color: '#fff' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 20,
          background: '#0b0b0b',
          borderBottom: '1px solid #1b1b1b',
          padding: '10px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 12,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ fontWeight: 800, letterSpacing: 0.3 }}>Milestones</div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 14 }}>
          <span style={{ opacity: 0.85 }}>{session.user?.email}</span>
          <button onClick={signOut} style={btnMini}>Logout</button>
        </div>
      </div>

      <Tracker session={session} />
    </div>
  );
}

const inp = {
  width: '100%',
  background: '#0e0e0f',
  color: '#fff',
  border: '1px solid #2a2a2a',
  borderRadius: 10,
  padding: '10px 12px',
  outline: 'none',
};

const btnPrimary = {
  width: '100%',
  background: '#12b886',
  color: '#000',
  border: 'none',
  borderRadius: 10,
  padding: '10px 12px',
  fontWeight: 800,
  cursor: 'pointer',
};

const btnMini = {
  background: '#262626',
  color: '#fff',
  border: '1px solid #333',
  borderRadius: 8,
  padding: '6px 10px',
  cursor: 'pointer',
};
